var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CheckoutPaymentCardContent',{attrs:{"icon":"cash-fast","title":"Pago en Efectivo"}},[(_vm.message)?_c('div',{staticClass:"pt-2"},[_vm._v(_vm._s(_vm.message))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }